const PlummeYearClosingChartAccounts = (() => {
  const list = (value) => Array.isArray(value) ? value : [];
  const cleanCode = (value, length = 4) => String(value ?? '').replace(/\D/g, '').slice(0, length);
  const accountCode = (account) => cleanCode(account?.code || account?.accountNumber || account?.id, 5);
  const mappedCode = (account) => cleanCode(account?.equivalentCode || account?.yearClosingStandardAccountCode || account?.standardAccountCode || account?.mapsToAccountCode);
  const canonicalCodes = (accounts) => new Set(list(accounts).map(accountCode).filter(Boolean));
  const missingCustomAccounts = (accounts, canonicalAccounts = []) => {
    const canonical = canonicalCodes(canonicalAccounts);
    return list(accounts).filter((account) =>
      account?.custom &&
      account?.active !== false &&
      accountCode(account) &&
      !mappedCode(account) &&
      !canonical.has(accountCode(account)));
  };
  const standardAccounts = (accounts) => list(accounts).filter((account) => !account?.custom && account?.active !== false && /^\d{4}$/.test(String(account?.code || '')));
  const words = (value) => new Set(String(value || '').toLowerCase().replace(/[^a-zæøå0-9 ]/gi, ' ').split(/\s+/).filter((word) => word.length > 2));
  const overlap = (left, right) => [...left].filter((word) => right.has(word)).length;
  const nameCodeHint = (account) => {
    const code = accountCode(account);
    const hint = String(account?.name || account?.label || '').match(/\b([1-8]\d{3})\b/)?.[1] || '';
    return hint && hint[0] === code[0] ? hint : '';
  };
  const proximityScore = (fromCode, candidateCode) => {
    const distance = Math.abs(Number(fromCode || 0) - Number(candidateCode || 0));
    return distance <= 99 ? Math.max(0, 10 - distance / 10) : 0;
  };
  const suggestionForAccount = (account, standards) => {
    const code = accountCode(account);
    const samePrefix = standards.find((candidate) => candidate.code === code.slice(0, 4));
    if (samePrefix) return samePrefix.code;
    const hint = nameCodeHint(account);
    if (hint) {
      const hinted = standards.filter((candidate) => candidate.code[0] === code[0] && candidate.code.slice(0, 2) === hint.slice(0, 2))
        .map((candidate) => ({ account: candidate, score: candidate.code === hint ? 100 : proximityScore(hint, candidate.code) }))
        .sort((a, b) => b.score - a.score)[0];
      if (hinted?.score >= 5) return hinted.account.code;
    }
    const ownWords = words(account?.name || account?.label);
    const ranked = standards.filter((candidate) => String(candidate.code || '')[0] === code[0]).map((candidate) => ({
      account: candidate,
      score: (hint && candidate.code === hint ? 40 : 0) +
        (hint && candidate.code.slice(0, 2) === hint.slice(0, 2) ? proximityScore(hint, candidate.code) : 0) +
        (candidate.code.slice(0, 3) === code.slice(0, 3) ? 20 : 0) +
        (candidate.code.slice(0, 2) === code.slice(0, 2) ? proximityScore(code, candidate.code) : 0) +
        overlap(ownWords, words(candidate.name)) * 5,
    })).sort((a, b) => b.score - a.score);
    return ranked[0]?.score >= 5 ? ranked[0].account.code : '';
  };
  const buildMappingSuggestions = (accounts) => {
    const standards = standardAccounts(accounts);
    return Object.fromEntries(missingCustomAccounts(accounts).map((account) => [accountCode(account), suggestionForAccount(account, standards)]).filter((entry) => entry[1]));
  };
  return { accountCode, mappedCode, missingCustomAccounts, standardAccounts, buildMappingSuggestions };
})();

globalThis.PlummeYearClosingChartAccounts = PlummeYearClosingChartAccounts;
